// extracted by mini-css-extract-plugin
module.exports = {"root":"layout_root__ybHKk","newsletter":"layout_newsletter__q7LNo"};